import { render } from "./PostView.vue?vue&type=template&id=15dad103&scoped=true"
import script from "./PostView.vue?vue&type=script&lang=js"
export * from "./PostView.vue?vue&type=script&lang=js"

import "./PostView.vue?vue&type=style&index=0&id=15dad103&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15dad103"]])

export default __exports__